import React from "react";
import { Spinner } from "reactstrap";

const MyLoader = () => {
  return (
    <>
    <div className="d-flex justify-content-center align-items-center">
      <Spinner
        style={{
          height: "3rem",
          width: "3rem",
          color:"#6f904f"
        }}
        type="grow"
      >
        Loading...
      </Spinner>
    </div>
    </>
  );
};

export default MyLoader;
